var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Admin"}},[_c('div',{staticClass:"vue-tree"},[_c('dd-tree',{staticClass:"item",attrs:{"model":_vm.treeData}})],1),_vm._v(" "),_c('button',{on:{"click":function($event){_vm.onClickGo('00000000000000000021_20180620174742662')}}},[_vm._v("Go")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d7e01738","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/pages/Admin.vue
// module id = null
// module chunks = 